export default function (rem: number): number {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
